module.exports = __webpack_public_path__ + "static/img/2.9608206.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/zh/2.png
// module id = 8B6a
// module chunks = 0